// import '../../../../Styles/Toyota.scss'

import React from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import LoadingGif from '../../../../static/images/loading.gif';
import TOLogo from '../../../../static/images/TO/toyota-logo.svg';

import AppVars from '../../../../AppVars.js';
import Logger from '../../../../Logger.js';

import {parseCookies, validateSessionToken} from 'account-portal-library/lib/helperFunctions';
import returnHeader from '../MiscHeaders'

let appVars = AppVars.getInstance()
let logger = Logger.getInstance();


class RegisterAppleFormView extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            ...props,

        };
    }

    render(){
        return(
            <div>
            <div className = "justify-content-center apple-line-box">
            <Col>
            <div role = "banner">
            <Row className = "">
            <a href = {appVars.getAppHomeURL(this.props.style)}><Image className = "corner-logo absolute" alt = "Toyota" src={require('../../../../static/images/Toyota-Logo.svg').default} /></a>
            </Row>
            </div>
            <div id = "appleRegisterFormAlert"
            data-testid = "appleRegisterFormError" 
            className = {`${this.props.isResponseValid === false ? "error-modal" : "none"}`} 
            role = "alert"
            aria-hidden = {`${this.props.isResponseValid === false ? "false" : "true"}`}>
            <div className = "error-modal-text">
                The service is down. Please try again shortly.
            </div>
            <span onClick={this.props.hideModal} className = "modal-close">&times;</span>
            </div>
            <div role = "main">
            <Row className = "justify-content-center location">
                <div>Apple Sign In</div>
            </Row>
            <Row className = "title__TO left">Please Provide Your Contact Details</Row>
            <Row>
            </Row>
            {returnHeader("APPLE", this.props.style)}

            <Form id = "appleRegisterForm" noValidate validated = {this.props.isFirstNameValid && this.props.isLastNameValid && this.props.isPhoneValid} onSubmit = {this.props.handleFormSubmit}>
            {/* <div id="requiredDiv"><span id="required"><span id="redStar">*</span>Required</span></div> */}
            <Form.Group id = "createFirstNameGroupApple" className = "relative">
                {/* NOTE: The native HTML5 validation disabled using noValidate in Form tag
                in order to disable native popup error*/}
                <Form.Label className = {`${this.props.floatFirstName === true ? "absolute floating-label" : "absolute inline-label" }
                                        ${this.props.firstNameFocus === true ? "label-black__TO" : "" }
                                        ${this.props.isFirstNameValid === false && this.props.firstNameFocus === false ? "label-red__TO" : ""}
                `}>
                    First Name<span id="redStar">*</span></Form.Label>
                <Form.Control
                    required
                    id = "createFirstName__TO"
                    data-testid = "createFirstName"
                    aria-label = "First Name"
                    as = "input"
                    type = "text"
                    name = "firstname"
                    placeholder = ""
                    value = {this.props.firstName}
                    onChange = {this.props.handleFirstNameChange}
                    onFocus = {this.props.setFocusFirstName}
                    onBlur = {this.props.onBlurFirstName}
                    bsPrefix = {`${this.props.isFirstNameValid === false && this.props.firstNameFocus === false ? "highlight-error__TO form-control" : ""}`}
                />
            <div
                id = "createFirstNameAlert" 
                data-testid = "createFirstNameError" 
                className = {`logon-item-error__TO ${this.props.isFirstNameValid === false && this.props.firstNameFocus === false ? "block" : "none"}`} 
                role = "alert"
                aria-hidden = {`${this.props.isFirstNameValid === false && this.props.firstNameFocus === false ? "false" : "true"}`}
            >
                Your first name must be between 1 and 14 characters. It can include spaces, apostrophes, and hyphens.
            </div>
            </Form.Group>
            <Form.Group id = "createLastNameGroupApple" className = "relative">
                {/* NOTE: The native HTML5 validation disabled using noValidate in Form tag
                in order to disable native popup error*/}
                <Form.Label className = {`${this.props.floatLastName === true ? "absolute floating-label" : "absolute inline-label" }
                                        ${this.props.lastNameFocus === true ? "label-black__TO" : "" }
                                        ${this.props.isLastNameValid === false && this.props.lastNameFocus === false ? "label-red__TO" : ""}
                `}>
                    Last Name<span id="redStar">*</span></Form.Label>
                <Form.Control
                    required
                    id = "createLastName__TO"
                    data-testid = "createLastName"
                    aria-label = "Last Name"
                    as = "input"
                    type = "text"
                    name = "lastname"
                    placeholder = ""
                    value = {this.props.lastName}
                    onChange = {this.props.handleLastNameChange}
                    onFocus = {this.props.setFocusLastName}
                    onBlur = {this.props.onBlurLastName}
                    bsPrefix = {`${this.props.isLastNameValid === false && this.props.lastNameFocus === false ? "highlight-error__TO form-control" : ""}`}
                />
            <div
                id = "createLastNameAlert" 
                data-testid = "createLastNameError" 
                className = {`logon-item-error__TO ${this.props.isLastNameValid === false && this.props.lastNameFocus === false ? "block" : "none"}`} 
                role = "alert"
                aria-hidden = {`${this.props.isLastNameValid === false && this.props.lastNameFocus === false ? "false" : "true"}`}
            >
                Your last name must be between 1 and 29 characters. It can include spaces, apostrophes, and hyphens.
            </div>
            </Form.Group>
            <Form.Group id = "createPhoneGroupApple" className = "relative">
            <Form.Label className = {`${this.props.floatPhone === true ? "absolute floating-label" : "absolute inline-label" }
                                    ${this.props.phoneFocus === true ? "label-black__TO" : "" }
                                    ${this.props.isPhoneValid === false && this.props.phoneFocus === false ? "label-red__TO" : ""}
            `}>
                Mobile Number<span id="redStar">*</span></Form.Label>
            <Form.Control
                required
                id = "createPhone__TO"
                data-testid = "createPhone"
                aria-label = "Phone"
                as = "input"
                type = "phone"
                name = "phone"
                placeholder = ""
                value = {this.props.phone}
                onChange = {this.props.handlePhoneChange}
                onFocus = {this.props.setFocusPhone}
                onBlur = {this.props.onBlurPhone}
                bsPrefix = {`${this.props.isPhoneValid === false && this.props.phoneFocus === false ? "highlight-error__TO form-control" : ""}`}
            />
            <div 
                id = "createPhoneAlert" 
                data-testid = "createPhoneError" 
                className = {`logon-item-error__TO ${this.props.isPhoneValid === false && this.props.phoneFocus === false ? "block" : "none"}`}
                role = "alert" 
                aria-hidden = {`${this.props.isPhoneValid === false && this.props.phoneFocus === false ? "false" : "true"}`}
            >
                Please enter a valid phone number.
            </div>
            <div 
                id = "createPhoneAlert" 
                data-testid = "createPhoneError" 
                className = {`logon-item-error__TO ${this.props.isPhoneAvailable === false && this.props.phoneFocus === false ? "block" : "none"}`}
                role = "alert" 
                aria-hidden = {`${this.props.isPhoneAvailable === false && this.props.phoneFocus === false ? "false" : "true"}`}
            >
                This mobile number is already in use.
            </div>
            </Form.Group>
            <div className = "required required-left-grid">
                <span id="redStar">*</span>Required
            </div>
            <div className = "apple-register-button">
            <Button id = "registerAppleButton" data-testid = "registerAppleButton" bsPrefix = {`${(this.props.isFirstNameValid && this.props.isLastNameValid && this.props.isPhoneValid) !== true ? "button-disabled__TO" : "button__TO "}`} type = "submit" >Next Step</Button>
            </div>
            <Image data-testid = "loadingGIF" className = {`working ${this.props.loading ? "" : "none"}`} id = "loadingGIF" src={LoadingGif} aria-hidden = "true"/>
        </Form>
        </div>
        </Col>
        </div>
        </div>

          
    );

    }

}




export default RegisterAppleFormView;